import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-support-times-policy-article',
  standalone: true,
  imports: [
    PolicyArticleComponent,
    ArticleTitleDirective,
    ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Support Policy and Turnaround Times</span>
      <div articleBody class="body-1-regular-1">
        <section>
          <div class="heading">Official Support Channels</div>
          <ul>
            <li>
              <b>Logging Support Requests: </b> To ensure efficient handling, governance, and security of support
              inquiries, all requests must be submitted through our official channels. This includes our online helpdesk
              platform and the designated helpdesk email address. Utilizing these channels ensures that all interactions
              are securely documented and accessible for audit and quality assurance purposes.
            </li>
            <li>
              <b>Importance of Official Channels: </b>
              <ul>
                <li><b>Record-Keeping and Governance:</b> Using the official channels helps us maintain a detailed and
                  accessible record of all support interactions. This is essential for internal governance, allowing us
                  to continually monitor and improve our support processes.
                </li>
                <li><b>Protecting Private/Confidential Information:</b> Our official channels are secured and monitored
                  to protect sensitive information. This ensures that private and confidential data shared during
                  support interactions are safeguarded against unauthorized access.
                </li>
                <li><b>Verification of Authorized Users:</b> To prevent unauthorized access and impersonation, we verify
                  the identity of all users through our official channels. This is a critical measure to ensure that
                  support is only provided to verified users or entities, thereby protecting your account and
                  information from potential security breaches.
                </li>
              </ul>
            </li>
            <li>
              <b>Exclusion of Unofficial Channels:</b> Support requests made through unofficial channels (social media,
              third-party platforms, or personal contacts) cannot be accepted. This policy is in place to protect user
              privacy, ensure security, and maintain effective record-keeping. We appreciate your understanding and
              cooperation in using the designated channels for all support inquiries.
            </li>
          </ul>
        </section>

        <section>
          <div class="heading">Team-Based Support Approach</div>
          <div>Our support model is a collaborative team effort, ensuring that no single person is responsible for any
            specific request. This approach:
          </div>
          <ul>
            <li>
              <b>Enhances Problem-Solving:</b> Leverages the collective expertise and experience of our support team,
              allowing for more efficient problem resolution.
            </li>
            <li>
              <b>Improves Availability and Response Times:</b> Ensures that support requests are not dependent on the
              availability of a single individual, thereby facilitating quicker and more consistent responses.
            </li>
            <li>
              <b>Ensures Continuity and Consistency:</b> Maintains a high standard of support by distributing knowledge
              and expertise across the team, preventing dependency on any one team member.
            </li>
          </ul>

          By adhering to our official support channels and understanding our team-based support approach, users can be
          assured of receiving efficient, secure, and effective assistance.
        </section>

        <section>
          <div class="heading">Priority and Response Times</div>
          <ul>
            <li>
              <b>Issue Prioritization:</b> Support requests are categorized and addressed based on the severity and
              impact of
              the issue reported. Our priority levels are:
              <ul>
                <li>
                  <b>Critical:</b> Issues that interrupt all or significant business operations and require immediate
                  attention.
                </li>
                <li>
                  <b>High:</b> Issues that significantly impair functionality but do not completely halt business
                  operations.
                </li>
                <li>
                  <b>Medium:</b> Issues that cause partial disruption or inconvenience with moderate impact.
                </li>
                <li>
                  <b>Low:</b> Issues with minimal impact, often related to general queries or minor problems.
                </li>
              </ul>
            </li>
            <li>
              <b>Assessment and Adjustment:</b> The initial priority assigned to a support request is based on our
              assessment
              and may be adjusted in response to further information from the client. For instance, if a critical issue
              is logged but the client takes a week to respond to follow-up queries, we may adjust the priority
              accordingly.
            </li>
            <li>
              <b>Turnaround Times:</b> Given the unique nature and requirements of each issue, we do not specify fixed
              turnaround times for resolving support requests. However, our policy guarantees that:
              <ul>
                <li>
                  Every support request will be acknowledged within 24 hours of submission. This acknowledgment will
                  confirm receipt and logging of the issue or query.
                </li>
                <li>
                  The acknowledgment will include an initial assessment of the issue's priority and, when possible, an
                  estimated timeline for further updates.
                </li>
              </ul>
            </li>
          </ul>
        </section>
        <section>
          <div class="heading">Commitment to Service</div>
          <div>Our support team is dedicated to resolving your issues efficiently and effectively, adhering to the
            highest standards of service. We understand the importance of timely support and are committed to continuous
            communication and updates regarding the status of your support requests.

            We appreciate your cooperation in using the official support channels and adhering to this policy, enabling
            us to safeguard your privacy and security while providing the assistance you need.
          </div>
        </section>
      </div>
    </app-policy-article>
  `
})
export class SupportTimesPolicyArticleComponent {

}
